import React, { useMemo } from 'react';
import { Maximize2 } from 'lucide-react';

const CORE_ORDER = ['A', 'B', 'V', 'G', 'D', 'E', 'Zh', 'Z', 'I', 'K', 'L', 'M', 'HRT', 'Man', 'SUN'];

const DEFAULT_LABELS = {
  A: 'А', B: 'Б', V: 'В', G: 'Г', D: 'Д', E: 'Е',
  Zh: 'Ж', Z: 'З', I: 'И', K: 'К', L: 'Л', M: 'М',
  HRT: 'HRT', Man: 'Man', SUN: '☀',
};

const DEFAULT_COLORS = {
  A: '#f97316', B: '#a855f7', V: '#f97316', G: '#22c55e',
  D: '#4f46e5', E: '#ef4444', Zh: '#3b82f6', Z: '#4f46e5',
  I: '#0ea5e9', K: '#6366f1', L: '#0ea5e9', M: '#eab308',
  HRT: '#10b981', Man: '#f59e0b', SUN: '#fbbf24',
};

const SizeEditor = ({ globalSize, nodeSizes, nodeLabels, nodeColors, onGlobalChange, onNodeSizeChange }) => {
  const effectiveGlobal = globalSize || 22;
  const sizes = nodeSizes || {};

  const allIds = useMemo(() => {
    const fromLabels = nodeLabels ? Object.keys(nodeLabels) : [];
    return [
      ...CORE_ORDER.filter(id => !fromLabels.length || id in (nodeLabels || {})),
      ...fromLabels.filter(id => !CORE_ORDER.includes(id)),
    ];
  }, [nodeLabels]);

  const getLabel = (id) => (nodeLabels && nodeLabels[id]) ? nodeLabels[id].letter : (DEFAULT_LABELS[id] || id);
  const getColor = (id) => (nodeColors && nodeColors[id]) || DEFAULT_COLORS[id] || '#a855f7';

  const setNodeSize = (id, value) => {
    const v = parseFloat(value);
    const updated = { ...sizes };
    if (isNaN(v) || v <= 0) delete updated[id];
    else updated[id] = v;
    onNodeSizeChange(updated);
  };

  const resetNode = (id) => {
    const updated = { ...sizes };
    delete updated[id];
    onNodeSizeChange(updated);
  };

  return (
    <div className="admin-section" data-testid="size-editor-section">
      <h3 className="admin-section-title">Sfera ölçüləri</h3>
      <p className="admin-section-desc">Qlobal ölçü və ya hər sfera üçün fərdi ölçü təyin edin.</p>

      <div className="size-global-wrap">
        <div className="flex items-center justify-between mb-2">
          <label className="text-sm font-semibold text-white/90 flex items-center gap-2">
            <Maximize2 size={14} /> Qlobal ölçü
          </label>
          <span className="text-sm font-mono text-purple-300" data-testid="global-size-value">
            {effectiveGlobal}px
          </span>
        </div>
        <input
          type="range" min="5" max="60" step="1"
          value={effectiveGlobal}
          onChange={(e) => onGlobalChange(parseFloat(e.target.value))}
          className="size-slider"
          data-testid="global-size-slider"
        />
      </div>

      <div className="size-divider">Fərdi ölçülər (boş = qlobal)</div>

      <div className="size-grid">
        {allIds.map((id) => {
          const override = sizes[id];
          const current = override || effectiveGlobal;
          return (
            <div key={id} className="size-item" data-testid={`size-item-${id}`}>
              <div className="size-item-header">
                <span
                  className="size-item-dot"
                  style={{
                    background: getColor(id),
                    width: `${Math.min(28, current * 0.9)}px`,
                    height: `${Math.min(28, current * 0.9)}px`,
                  }}
                />
                <span className="size-item-label">{getLabel(id)}</span>
                <span className="size-item-id">{id}</span>
              </div>
              <div className="size-item-controls">
                <input
                  type="range" min="5" max="60" step="1"
                  value={current}
                  onChange={(e) => setNodeSize(id, e.target.value)}
                  className="size-slider-small"
                  data-testid={`size-slider-${id}`}
                />
                <span className="size-item-value">{current}px</span>
                {override !== undefined && (
                  <button
                    onClick={() => resetNode(id)}
                    className="size-reset-btn"
                    title="Qlobala qaytar"
                    data-testid={`size-reset-${id}`}
                  >×</button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SizeEditor;
